var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-section"},[_c('h4',{staticClass:"info-heading"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"info-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }